import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CompanyThemeActivityGraphComponent } from '../company-theme-activity-graph/company-theme-activity-graph.component';
import { InventionsViewComponent } from '../inventions-view/inventions-view.component';

export interface CompanyThemePopupData {
  entityid: string;
  entity_name: string;
  theme_label: string;
  theme_search_type: 'cluster' | 'custom';
  cluster_id?: number | string | null;
  cluster_name?: string | null;
  query?: string | null;
  tabId: string;
}

type View = 'activity' | 'inventions';

@Component({
  selector: 'app-company-theme-popup',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, CompanyThemeActivityGraphComponent, InventionsViewComponent],
  templateUrl: './company-theme-popup.component.html',
  styleUrl: './company-theme-popup.component.css',
})
export class CompanyThemePopupComponent {
  view: View = 'activity';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CompanyThemePopupData,
    private dialogRef: MatDialogRef<CompanyThemePopupComponent>,
  ) {}

  showActivity(): void { this.view = 'activity'; }
  showInventions(): void { this.view = 'inventions'; }
  close(): void { this.dialogRef.close(); }
}
